import template from './property-type.jade';
import items from '../../../enums/property-type';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.propertyType', [])
    .directive('cianAfAboutObjectPropertyType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.items = items;
            this.validation = validation(this.form, 'propertyType', {
                required: 'Обязательное поле'
            });
        },
        controllerAs: 'propertyType',
        template,
    }))
    .name;
